export default __webpack_public_path__ + "static/media/before.8f90eff1.png";